import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ClipboardCopy/clipboard-copy';
import { css } from '@patternfly/react-styles';
export var ClipboardCopyExpanded =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClipboardCopyExpanded, _React$Component);

  function ClipboardCopyExpanded(props) {
    _classCallCheck(this, ClipboardCopyExpanded);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardCopyExpanded).call(this, props));
  }

  _createClass(ClipboardCopyExpanded, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          onChange = _a.onChange,
          isReadOnly = _a.isReadOnly,
          isCode = _a.isCode,
          props = __rest(_a, ["className", "children", "onChange", "isReadOnly", "isCode"]);

      return React.createElement("div", Object.assign({
        suppressContentEditableWarning: true,
        className: css(styles.clipboardCopyExpandableContent, className),
        onInput: function onInput(e) {
          return onChange(e.target.innerText, e);
        },
        contentEditable: !isReadOnly
      }, props), isCode ? React.createElement("pre", null, children) : children);
    }
  }]);

  return ClipboardCopyExpanded;
}(React.Component);
ClipboardCopyExpanded.defaultProps = {
  onChange: function onChange() {
    return undefined;
  },
  className: '',
  isReadOnly: false,
  isCode: false
};